import { Locale } from './types/global';

export const SUPPORTED_LANGUAGES: Record<Locale, string> = {
  en: 'English',
  zh: '中文'
};

type TranslationKey =
  | 'siteTitle'
  | 'collection'
  | 'stories'
  | 'authors'
  | 'about'
  | 'filterLabel'
  | 'allTag'
  | 'yearLabel'
  | 'viewDetails'
  | 'closeDetails'
  | 'nextImage'
  | 'previousImage'
  | 'languageLabel'
  | 'themeLabel'
  | 'themeLight'
  | 'themeDark'
  | 'themeSystem'
  | 'emptyState'
  | 'loadingState'
  | 'errorState'
  | 'storiesEmptyState'
  | 'storiesLoadingState'
  | 'storiesErrorState'
  | 'authorsEmptyState'
  | 'authorsLoadingState'
  | 'authorsErrorState'
  | 'authorLabel'
  | 'authorFilterLabel'
  | 'authorFilterPlaceholder';

const translations: Record<Locale, Record<TranslationKey, string>> = {
  en: {
    siteTitle: 'SONSEN',
    collection: 'Collection',
    stories: 'Stories',
    authors: 'Artisans',
    about: 'About',
    filterLabel: 'Filter by Category',
    allTag: 'All',
    yearLabel: 'Year',
    viewDetails: 'View details',
    closeDetails: 'Back to collection',
    nextImage: 'Next image',
    previousImage: 'Previous image',
    languageLabel: 'Language',
    themeLabel: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    emptyState: 'No pieces match the selected categories.',
    loadingState: 'Loading collection…',
    errorState: 'Unable to load the collection. Please try again.',
    storiesEmptyState: 'No stories to share yet — check back soon.',
    storiesLoadingState: 'Loading stories…',
    storiesErrorState: 'Unable to load stories. Please try again.',
    authorsEmptyState: 'No artisan profiles available at this time.',
    authorsLoadingState: 'Loading artisans…',
    authorsErrorState: 'Unable to load artisans. Please try again.',
    authorLabel: 'Artisan',
    authorFilterLabel: 'Search artisans',
    authorFilterPlaceholder: 'Search by name'
  },
  zh: {
    siteTitle: '淞圣',
    collection: '臻品',
    stories: '匠心故事',
    authors: '工艺大师',
    about: '关于',
    filterLabel: '按类别筛选',
    allTag: '全部',
    yearLabel: '创作年份',
    viewDetails: '查看详情',
    closeDetails: '返回臻品集',
    nextImage: '下一张',
    previousImage: '上一张',
    languageLabel: '语言',
    themeLabel: '主题',
    themeLight: '浅色',
    themeDark: '深色',
    themeSystem: '跟随系统',
    emptyState: '暂无符合所选类别的作品。',
    loadingState: '正在载入臻品…',
    errorState: '载入失败，请稍后再试。',
    storiesEmptyState: '暂无故事，敬请期待。',
    storiesLoadingState: '正在载入故事…',
    storiesErrorState: '载入故事失败，请稍后再试。',
    authorsEmptyState: '暂无工艺大师信息。',
    authorsLoadingState: '正在载入工艺大师…',
    authorsErrorState: '载入失败，请稍后再试。',
    authorLabel: '工艺师',
    authorFilterLabel: '搜索工艺大师',
    authorFilterPlaceholder: '按姓名搜索'
  }
};

export const translate = (locale: Locale, key: TranslationKey) => translations[locale][key];
